<template>
  <div>
    <div>
      <span class="xbed-sub-title">小程序管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>微信</BreadcrumbItem>
        <BreadcrumbItem>小程序管理</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <section style="margin-top:20px">
      <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem label="小程序：" prop="dictValueId" :label-width="84">
              <Select v-model="queryParams.dictValueId" clearable filterable style="width:160px">
                <Option v-for="(item, index) in invoiceList" :key="index" :value="item.id">{{item.dictDesc}}</Option>
              </Select>
          </FormItem>
          <FormItem prop="pageName" label="页面名称：" :label-width="84">
              <Input type="text" v-model="queryParams.pageName" :maxlength="100" style="width:160px"></Input>
          </FormItem>
          <FormItem label="失效状态：" prop="expireStatus" :label-width="84">
              <Select v-model="queryParams.state" clearable filterable style="width:160px">
                  <Option value="">不限</Option>
                  <Option value="1">有效</Option>
                  <Option value="0">无效</Option>
              </Select>
          </FormItem>
          <FormItem style="margin-left:45px;">
              <Button type="primary" @click="queryWxappListFn">查询</Button>
              <Button type="primary" @click="openAddUrlModal" style="margin-left:10px;">新增外链</Button>
          </FormItem>
      </Form>

      <Table stripe :columns="table.columns" :data="table.data" :loading="table.loading"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :current="queryParams.page" :total="table.total" :page-size="queryParams.size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </section>

    <Modal v-model="addUrlModal.display" ref="addUrlModal" title="新增外链" :loading="true" @on-ok="doClickAddWxappUrlFn">
      <Form @submit.native.prevent="preventSubmit" :model="addUrlModal" ref="addUrlModalForm" :label-width="84">
        <FormItem prop="dictValueId" label="小程序：">
          <Select v-model="addUrlModal.dictValueId" clearable filterable style="width:260px">
            <Option v-for="(item, index) in invoiceList" :key="index" :value="item.id">{{item.dictDesc}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="pageName" label="页面名称：">
          <Input type="text" style="width: 260px;" v-model="addUrlModal.pageName" />
        </FormItem>
        <FormItem prop="pagePath" label="页面地址：">
          <Input type="text" style="width: 260px;" v-model="addUrlModal.pagePath" />
        </FormItem>
        <FormItem prop="expireTime" label="失效时间：">
          <DatePicker style="width: 260px" type="datetime" :value="addUrlModal.expireTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期" :options="dateOptions" @on-change="doChangeDateTimeFn"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
    }
	},
  data(){
    return {
      invoiceList: [],
      queryParams: {
        page:1,
        pageSize:10,
        dictValueId: '',
        pageName: '',
        state: ''
      },
      table: {
        loading: false,
				data: [],
				total: 0,
        columns: [
        {
          title: "ID",
          key: "auid",
          align: "center",
          width: 80
        },
        {
          title: "小程序",
          key: "appName",
          align: "center",
          width: 100
        },
        {
          title: "页面名称",
          key: "pageName",
          align: "center",
          width: 120
        },
        {
          title: "页面地址",
          key: "pagePath",
          align: "center",
          width: 220
        },
        {
          title: "外链地址",
          key: "url",
          align: "center",
          width: 280
        },
        {
          title: "失效时间",
          key: "expireTime",
          align: "center",
          width: 240
        },
        {
          title: "创建时间",
          key: "createTime",
          align: "center",
          width: 240
        },
        {
          title: "操作",
          align: "center",
          width: 220,
          render: (h, params) => {
            return h("div", [
               h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doClickCopyLinkFn(params.row)
                    }
                  }
                },
                "复制链接"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginLeft: '5px',
                    visibility: new Date(params.row.expireTime).getTime() < new Date().getTime()?'visible':'hidden'
                  },
                  on: {
                    click: () => {
                      if (!Utils.hasPermission('wxappUrlDel')) {
                        this.$Notice.error( {
                          title: "无权限操作"
                        } );
                        return
                      }
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定删除这条生成的小程序外链信息吗？`;
                          return modalH(
                            "div",
                            {
                              style: {
                                fontSize: "16px"
                              }
                            },
                            modalText
                          );
                        },
                        onOk: () => {
                          this.deleteWxappUrlFn(params.row);
                        }
                      });
                    }
                  }
                },
                "删除"
              )
            ])
          }
        }],
      },
      addUrlModal: {
        display: false,
        dictValueId: '',
        pageName: '',
        pagePath: '',
        preExpireTime: '',
        expireTime: ''
      },
      dateOptions: {
        disabledDate (time) {
          let pickerTime = time.getTime()
          let curDateTime = (new Date()).getTime()
          let oneDayTime = 24 * 3600 * 1000
          let endDayTime = curDateTime + 30 * 24 * 3600 * 1000
          return pickerTime < curDateTime - oneDayTime || pickerTime > endDayTime
        }
      },
    }
  },
  mounted () {
    this.getDictValuelistFn()
    this.queryWxappListFn()
  },
  methods:{
    async getDictValuelistFn() {
      try {
        let params = {
          pageNum: 1,
          pageSize: 100,
          groupId: 49
        }
        const resp = (await API.omsAPI[this.env].clientServer.dictValueList(params, this.protHeaders)).data;
        if(resp.retCode){
          this.$Notice.error({
            title: '获取数据失败',
            desc: resp.msg
          })
          return
        }
        this.invoiceList = resp.list
      } catch (e) {
        this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
      }
    },
    async queryWxappListFn() {
      if (!Utils.hasPermission('wxappUrlList')) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      try {
        let params = this.queryParams
        this.table.loading = true;
        let headers = this.protHeaders
        let resp = (await API.omsAPI[this.env].clientServer.getWxappurlList(params, headers)).data;
        if (resp.retCode && resp.retCode != 21020000) {
          this.$Notice.error({
            title: '获取活动管理数据失败',
            desc: resp.msg
          })
          return
        }
      this.table.data = resp.content;
			this.table.total = resp.totalCount;
			this.table.loading = false
      } catch (e) {
        this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
      }
    },

    changePage(page) {
			this.queryParams.page = page;
			this.queryWxappListFn();
		},

		changePageSize(pageSize) {
			this.queryParams.page = 1;
			this.queryParams.pageSize = pageSize;
			this.queryWxappListFn();
		},

    openAddUrlModal() {
      if (!Utils.hasPermission('wxappUrlAdd')) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      this.addUrlModal = Object.assign({}, this.addUrlModal, {
        display: true,
        addUrlModal: false,
        appId: "",
        appName: "",
        dictValueId: '',
        pageName: "",
        pagePath: "",
        preExpireTime: "",
        expireTime: ""
      })
    },

    doClickAddWxappUrlFn() {
      if (!this.addUrlModal.dictValueId) {
        this.$Notice.error({
          title: '请选择小程序'
        })
        this.$refs.addUrlModal.buttonLoading = false;
        return
      }

      if (!this.addUrlModal.pageName) {
         this.$Notice.error({
          title: '页面名称不能为空'
        })
        this.$refs.addUrlModal.buttonLoading = false;
        return
      }

      if (!this.addUrlModal.pagePath) {
         this.$Notice.error({
          title: '页面地址不能为空'
        })
        this.$refs.addUrlModal.buttonLoading = false;
        return
      }

      if (!this.addUrlModal.expireTime) {
         this.$Notice.error({
          title: '请选择失效时间'
        })
        this.$refs.addUrlModal.buttonLoading = false;
        return
      } else if (new Date(this.addUrlModal.expireTime).getTime() < new Date().getTime()) {
        this.$Message.error('选择的时间已失效，请重新选择');
        this.addUrlModal.preExpireTime = ""
        this.addUrlModal.expireTime = ""
        this.$refs.addUrlModal.buttonLoading = false;
        return
      }
      this.addWxappurlFn()
    },

    async addWxappurlFn() {
      try {
        for(let a=0; a<this.invoiceList.length; a++) {
          if(this.invoiceList[a].id == this.addUrlModal.dictValueId){
            this.addUrlModal = Object.assign({}, this.addUrlModal, {
              appId: this.invoiceList[a].dictName,
              appName: this.invoiceList[a].dictDesc
            })
            break
          }
        }
        let params = {
          appId: this.addUrlModal.appId,
          appName: this.addUrlModal.appName,
          dictValueId: this.addUrlModal.dictValueId,
          pageName: this.addUrlModal.pageName,
          pagePath: this.addUrlModal.pagePath,
          expireTime: this.addUrlModal.expireTime
        }
        let headers = {
          'x-ca-stage': Utils.aliHeaderEnv(this.env), 
          'Authorization': Utils.findFromLocalStorage("Author-token"),
          'isForm': true
        }
        const resp = (await API.omsAPI[this.env].clientServer.createWxappurl(params, headers)).data;
        this.addUrlModal.loading = false
        this.$refs.addUrlModal.buttonLoading = false;
        if (resp.retCode && resp.retCode != 21020000) {
          this.$Notice.error({
            title: "新增小程序外链失败",
            desc: resp.msg
          });
          return
        } 
        this.$Notice.success({
          title: "新增小程序外链成功"
        });
        this.addUrlModal.display = false
        this.queryParams.page = 1;
        this.queryWxappListFn();
      }catch (e) {
        this.$refs.addUrlModal.buttonLoading = false;
        this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
      }
    },

    async deleteWxappUrlFn(wxappUrlObj) {
      try {
        let resp = (await API.omsAPI[this.env].clientServer.deleteWxappurl(wxappUrlObj.auid, this.protHeaders)).data;
        if (resp.retCode && resp.retCode != 21020000) {
          this.$Notice.error({
            title: '删除外链数据失败',
            desc: resp.msg
          })
          return
        }
        this.$Notice.success({
          title: '删除外链数据成功',
        })
      this.queryParams.page = 1;
			this.queryWxappListFn();
      } catch (e) {
        this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
      }
    },

    doClickCopyLinkFn(wxappUrlObj) {
      navigator.clipboard.writeText(wxappUrlObj.url).then(() => {
        this.$Message.success('复制成功');
      });
    },

    doChangeDateTimeFn(dateTime) {
      let year = new Date(dateTime).getFullYear()
      let month = (new Date(dateTime).getMonth())+1 < 10 ? '0' + (new Date(dateTime).getMonth()+1): (new Date(dateTime).getMonth()) + 1
      let day = new Date(dateTime).getDate()<10 ? '0'+ new Date(dateTime).getDate() : new Date(dateTime).getDate()
      let selectDate = year + '-' + month + '-' + day

      if (this.addUrlModal.preExpireTime == "") {
        this.addUrlModal.preExpireTime = selectDate + ' 23:59:59'
        this.addUrlModal.expireTime = selectDate + ' 23:59:59'
      } else if (new Date(this.addUrlModal.preExpireTime).getDate()!= new Date(dateTime).getDate()) {
        this.addUrlModal.preExpireTime = selectDate + ' 23:59:59'
        this.addUrlModal.expireTime = selectDate + ' 23:59:59'
      } else {
        let hour = new Date(dateTime).getHours() < 10 ?  '0' + new Date(dateTime).getHours() : new Date(dateTime).getHours()
        let min = new Date(dateTime).getMinutes() < 10 ?  '0' + new Date(dateTime).getMinutes() : new Date(dateTime).getMinutes()
        let second = new Date(dateTime).getSeconds() < 10 ?  '0' + new Date(dateTime).getSeconds() : new Date(dateTime).getSeconds()
        let selectTime = hour + ':' + min + ':' + second
        this.addUrlModal.preExpireTime = selectDate + ' ' + selectTime
        this.addUrlModal.expireTime = selectDate + ' ' + selectTime
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/wechat/minprogram-manage.vue